const isEmptyOrSpaces = str => str === null || str.match(/^ *$/) !== null;

export default isEmptyOrSpaces;